import { Exercise } from "../../app/models/Exercise";

/**
 * Hook do generowania linków do Kalendarza Google
 */
export default function useGoogleCalendar() {
  /**
   * Generuje link do Kalendarza Google na podstawie informacji o wydarzeniu
   * @param title - Nazwa wydarzenia
   * @param startTime - Czas rozpoczęcia (timestamp)
   * @param endTime - Czas zakończenia (timestamp)
   * @param details - Szczegóły wydarzenia
   * @returns URL do dodania wydarzenia do Kalendarza Google
   */
  const generateGoogleCalendarUrl = (title: string, startTime: number, endTime: number, details?: string): string => {
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);

    // Format dat dla URL Kalendarza Google (YYYYMMDDTHHMMSSZ)
    const formatDate = (date: Date) => {
      return date.toISOString().replace(/-|:|\.\d+/g, "");
    };

    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    // Utwórz szczegóły wydarzenia
    const eventDetails = {
      action: "TEMPLATE",
      text: title,
      details: details || "",
      dates: `${formattedStart}/${formattedEnd}`,
    };

    // Generuj URL z parametrami
    const params = new URLSearchParams();
    Object.entries(eventDetails).forEach(([key, value]) => {
      params.append(key, value);
    });

    return `https://calendar.google.com/calendar/render?${params.toString()}`;
  };

  /**
   * Generuje link do Kalendarza Google na podstawie obiektu Exercise
   * @param exercise - Obiekt Exercise
   * @returns URL do dodania wydarzenia do Kalendarza Google
   */
  const generateGoogleCalendarUrlFromExercise = (exercise: Exercise): string => {
    const details = exercise.description || "";

    return generateGoogleCalendarUrl(exercise.name, exercise.startTime, exercise.closeTime, details);
  };

  return {
    generateGoogleCalendarUrl,
    generateGoogleCalendarUrlFromExercise,
  };
}
